import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { Redirect } from 'react-router-dom'
import { withStyles } from '@material-ui/core/styles'

import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'

import BreadCrumb from 'components/atoms/BreadCrumb'
import UserTraps from 'components/organisms/UserTraps'
import UserGroups from 'components/organisms/UserGroups'
import InkyCarousel from 'components/organisms/InkyCarousel'
import SubmitButton from 'components/atoms/buttons/SubmitButton'

import { capitiliseFirstLetter } from 'utils/formatting'
import { formatDate, LOCAL_DATE_FORMAT } from 'utils/date'

export const styles = theme => ({
  root: {},
  title: {
    fontSize: 32,
    color: theme.palette.black,
    marginBottom: theme.spacing(4),
  },
  body: {
    paddingBottom: theme.spacing(4),
  },
  details: {
    width: 300,
  },
  deleteButton: {
    cursor: 'pointer',
    margin: `${theme.spacing(4)}px auto ${theme.spacing(4)}px 0`,
  },
  assignButton: {
    marginLeft: theme.spacing(3),
  },
})

const PeopleDetails = ({
  user,
  isYou,
  classes,
  onUserDeleteClick,
  onGroupAssignClick,
}) => (
  <div className={classes.root}>
    {user ? (
      <Fragment>
        <Grid container justify="space-between">
          <BreadCrumb
            links={[{ label: 'All people', to: '/dashboard/people/all' }]}
            currentPageLabel={user.fullName}
          />
          <SubmitButton
            size="medium"
            color="primary"
            variant="primary"
            showLoader={false}
            onClick={onGroupAssignClick}
            className={classes.assignButton}>
              Assign to groups
          </SubmitButton>
        </Grid>
        <Grid
          container
          direction="column"
          justify="space-between"
          className={classes.body}>
          <Typography className={classes.title} variant="h5">
            {user.fullName}
            {isYou ? ' ( you )' : ''}
          </Typography>
          <Grid container className={classes.details}>
            <Grid item sm={5}>
              <Typography>Email:</Typography>
            </Grid>
            <Grid item sm={7}>
              <Typography>{user.email}</Typography>
            </Grid>
            <Grid item sm={5}>
              <Typography>Joined:</Typography>
            </Grid>
            <Grid item sm={7}>
              <Typography>
                {formatDate(user.updatedAt, LOCAL_DATE_FORMAT)}
              </Typography>
            </Grid>
            <Grid item sm={5}>
              <Typography>Type:</Typography>
            </Grid>
            <Grid item sm={7}>
              <Typography>{capitiliseFirstLetter(user.role)}</Typography>
            </Grid>
          </Grid>
          <Typography
            color="primary"
            className={classes.deleteButton}
            onClick={onUserDeleteClick}>
              Delete user
          </Typography>
          <InkyCarousel>
            <UserGroups name="Assigned Groups" />
            <UserTraps name="Installed Traps" />
          </InkyCarousel>
        </Grid>
      </Fragment>
    ) : (
      <Redirect to={{ pathname: '/dashboard/people/all' }} />
    )}
  </div>
)

PeopleDetails.propTypes = {
  isYou: PropTypes.bool,
  user: PropTypes.object,
  onUserDeleteClick: PropTypes.func,
  onGroupAssignClick: PropTypes.func,
  classes: PropTypes.object.isRequired,
  organisationHasGroups: PropTypes.bool,
}

export default withStyles(styles)(PeopleDetails)



// WEBPACK FOOTER //
// ./src/containers/people/PeopleDetails/PeopleDetails.js